/* eslint-disabled */
import Avenant from "./Avenant";
import Item from "./Item";
import Risk from "./Risk";
import Pack from "./Pack";
import Printable from "./Printable";
import Insurer from "./Insurer";
import CoverageExtend from "@/entity/extends/CoverageExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Coverage extends CoverageExtend {

    public uuid? = '';
    public avenant!: Avenant;
    public item!: Item;
    public createdAt?: Date;
    public label? = '';
    public risks: Array<Risk> = [];
    public isActive!: boolean;
    public pack!: Pack;
    public premium!: number;
    public details= [];
    public startAt?: Date;
    public endAt?: Date;
    public printables: Array<Printable> = [];
    public status? = '';
    public basePremium!: number;
    public optionalPremium?: number;
    public insurer!: Insurer;

    constructor (object?: any) {
        super(object)
        if(object){
            this.uuid= object.uuid;
            this.avenant = (object.avenant instanceof Avenant) ? object.avenant : object.avenant ? new Avenant(object.avenant) : object.avenant;
            this.item = (object.item instanceof Item) ? object.item : object.item ? new Item(object.item) : object.item;
            if(object.createdAt){
                this.createdAt= new Date(object.createdAt);
            }
            this.label= object.label;
            hydrateCollection(object.risks, Risk, this.risks);
            this.isActive= object.isActive;
            this.pack = (object.pack instanceof Pack) ? object.pack : object.pack ? new Pack(object.pack) : object.pack;
            this.premium= object.premium;
            this.details= object.details;
            if(object.startAt){
                this.startAt= new Date(object.startAt);
            }
            if(object.endAt){
                this.endAt= new Date(object.endAt);
            }
            hydrateCollection(object.printables, Printable, this.printables);
            this.status= object.status;
            this.basePremium= object.basePremium;
            this.optionalPremium= object.optionalPremium;
            this.insurer = (object.insurer instanceof Insurer) ? object.insurer : object.insurer ? new Insurer(object.insurer) : object.insurer;
        }
        this.postConstruct()
    }

}
